import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Shared state for uploading, downloading, and deleting knowledge-base
 * attribute documents. Reusable by any feature that needs to attach a
 * document to a knowledge-base target (e.g. Mosaic, DMS).
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link Api} */
  public readonly api = ngCore.inject(Api)

  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'KbDocumentUploads',
      selectors: () => new Selectors(this),
    })

    this.registerEffects(
      effects.executeUpload(),
      effects.executeDownload(),
      effects.executeDelete(),
    )
  }
}
